<template>
  <MUIDialog
    :displayType="displayType"
    :acceptItem="acceptItem"
    :dismissItem="dismissItem"
    :title="title"
    ref="dialog">
    <div class="form-group field-input">
      <div class="field-wrap">
        <input
          data-vv-delay='1000'
          name='url'
          ref='urlInput'
          type='url'
          placeholder='Paste or type URL'
          v-model.trim='url'>
      </div>
      <span v-if="error" class="help is-danger">{{error}}</span>
    </div>
  </MUIDialog>
</template>

<script>
import { APP } from '../config'
import { ensureProtocol, errorMessages } from '../utils'
import validUrl from 'valid-url'

import {
  MUIDialog
} from '../components'

export default {
  components: {
    MUIDialog
  },
  props: {
    collectionKey: String,
    url: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      acceptItem: {
        name: 'Save',
        fn: () => this.acceptHandler()
      },
      dismissItem: {
        name: 'Cancel'
      },
      displayType: APP,
      errors: [],
      title: 'Add Recipe from a Website'
    }
  },
  computed: {
    error () {
      return this.errors.length > 0 && errorMessages().url[this.errors[0]]
    }
  },
  methods: {
    acceptHandler () {
      this.errors = []
      if (!this.url) return this.errors.push('required')
      if (!validUrl.isWebUri(ensureProtocol(this.url))) return this.errors.push('format')

      let recipe = {
        extractionState: 'added',
        givenUrl: ensureProtocol(this.url),
        sourceType: 'article'
      }

      this.$store.dispatch('createRecipe', {
        userId: this.$store.state.User.uid,
        recipe,
        collectionId: this.collectionKey === 'library' ? null : this.collectionKey
      }).then((key) => {
        this.$refs.dialog.close()
        let path = this.$urlHelpers.collectionRecipePath(this.collectionKey, key)
        this.$router.currentRoute.path !== path && this.$router.push(path)
        this.$track('recipe.add', {
          context: 'recipe',
          ability: 'add',
          recipeId: key,
          sourceType: 'article'
        })
      })
    }
  },
  mounted () {
    this.$refs.urlInput.focus()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/AddDialog.vue